<style lang="scss" scoped>
.lotteryList-wrapper{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  overflow: hidden;
  &-air{
    width:522px;
    height:500px;
    background:rgba(255,255,255,1);
    border-radius:8px;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    &-close{
      width: 16px;
      height: 16px;
      position: absolute;
      right: 12px;
      top: 12px;
      background: url('./../assets/img/group7.svg') no-repeat;
      background-size: cover;
      cursor: pointer;
    }
    &-title{
      margin-top: 16px;
      width: 100%;
      text-align: center;
      font-size:22px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(15,22,43,1);
      line-height:22px;
      border-bottom: 1px solid #F3F3F3;
    }
    &-img{
      margin-top: 78px;
      width: 174px;
      height: 186px;
    }
    &-tips{
      margin-top: 56px;
      font-size:18px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(114,120,140,1);
      line-height:17px;
    }
  }
  &-content{
    width:620px;
    height:384px;
    background:rgba(255,255,255,1);
    border-radius:8px;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 51px 0 0 0;
    &-close{
      width: 16px;
      height: 16px;
      position: absolute;
      z-index: 3;
      right: 12px;
      top: 12px;
      background: url('./../assets/img/group7.svg') no-repeat;
      background-size: cover;
      cursor: pointer;
    }
    &-title{
      width: 100%;
      height: 51px;
      text-align: center;
      font-size:16px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(15,22,43,1);
      line-height:52px;
      background: #fff;
      position: absolute;
      z-index: 2;
      left: 0;
      top: 0;
      border-bottom: 1px solid rgb(235, 232, 232);
      // transform: translateX(-38px);
      // transform: translateY(-51px);
    }
    &-list{
      flex: 1;
      height: 330px;
      // margin-top: 51px;
      position: relative;
      ul{
        li{
          height: 79px;
          border-bottom: 1px solid rgb(235, 232, 232);
          display: flex;
          // flex-direction: column;
          align-items: center;
          padding: 0 28px;
          position: relative;
          button{
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
          }
          .object{
            .lotteryList-wrapper-content-list-item-object-top{
              height: 72px;
              display: flex;
              &-left{
                width: 60px;
                margin-right: 12px;
                position: relative;
                img{
                  position: absolute;
                  left: 4px;
                  top: 12px;
                  width: 48px;
                  height: 48px;
                }
              }
              &-right{
                // float: left;
                // width: 185px;
                overflow: hidden;
                p {
                  font-size:13px;
                  font-family:PingFangSC-Regular;
                  font-weight:400;
                  color:rgba(114,120,140,1);
                  line-height:18px;
                  text-align: left;
                }
                span{
                  color: #0F162B;
                }
                &-name{
                  margin-top: 15px;
                }
                &-date{
                  margin-top: 6px;
                }
              }
              button{
                position: absolute;
                right: 20px;
                top: 50%;
                transform: translateY(-50%);
                width: 128px;
                height: 40px;
                background: url('./../assets/img/dizhi_btn.svg') no-repeat;
                background-size: cover;
                font-size:14px;
                font-family:PingFangSC-Medium;
                font-weight:500;
                color:rgba(194,52,18,1);
                border-radius:20px;
                cursor: pointer;
              }
            }
          }
          .wequan{
            .lotteryList-wrapper-content-list-item-wequan-top{
                height: 72px;
                display: flex;
              &-left{
                width: 60px;
                margin-right: 12px;
                position: relative;
                img{
                  position: absolute;
                  left: 4px;
                  top: 12px;
                  width: 48px;
                  height: 48px;
                }
              }
              &-right{
                float: left;
                // width: 185px;
                overflow: hidden;
                p {
                  font-size:13px;
                  font-family:PingFangSC-Regular;
                  font-weight:400;
                  color:rgba(114,120,140,1);
                  line-height:18px;
                  text-align: left;
                }
                span{
                  color: #0F162B;
                }
                &-name{
                  margin-top: 15px;
                }
                &-date{
                  margin-top: 6px;
                }
              }
              button{
                width:128px;
                height:40px;
                background: url('./../assets/img/yifafang_btn.svg') no-repeat;
                background-size: cover;
                border-radius:20px;
                background-size: cover;
                font-size:14px;
                font-family:PingFangSC-Medium;
                font-weight:500;
                color:rgba(255,255,255,1);
                border-radius:20px;
                // transform: translateX(140px);
                // cursor: pointer;
              }
            }
          }
          .redeem{
            .lotteryList-wrapper-content-list-item-redeem-top{
                height: 72px;
                display: flex;
              &-left{
                width: 60px;
                margin-right: 12px;
                position: relative;
                img{
                  position: absolute;
                  left: 4px;
                  top: 12px;
                  width: 48px;
                  height: 48px;
                }
              }
              &-right{
                // display: flex;
                align-items: center;
                float: right;
                justify-content: right;
                p {
                  font-size:13px;
                  font-family:PingFangSC-Regular;
                  font-weight:400;
                  color:rgba(114,120,140,1);
                  line-height:18px;
                  text-align: left;
                }
                span{
                  color: #0F162B;
                }
                &-name{
                  margin-top: 15px;
                }
                &-date{
                  margin-top: 6px;
                }
              }
              button{
                width: 128px;
                height: 40px;
                background: url('./../assets/img/duihuanma_btn.svg') no-repeat;
                background-size: cover;
                font-size:14px;
                font-family:PingFangSC-Medium;
                font-weight:500;
                color:rgba(194,52,18,1);
                border-radius:20px;
                // transform: translateX(140px);
                cursor: pointer;
                // position: relative;
              }
            }
          }
        }
      }
    }
  }
  .mask{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    background:rgba(0,0,0,1);
    opacity:0.6009;
  }
}
</style>

<template>
  <div class="lotteryList-wrapper" v-show="showPrizeList">
    <div class="lotteryList-wrapper-air" v-if="isAir">
      <span class="lotteryList-wrapper-air-close" @click="showPrizeList = false"></span>
      <p class="lotteryList-wrapper-air-title">我的奖品</p>
      <img class="lotteryList-wrapper-air-img" src="./../assets/img/group42.svg" alt="">
      <p class="lotteryList-wrapper-air-tips">您还未参与抽奖哦!</p>
    </div>
    <div class="lotteryList-wrapper-content" v-else>
      <span class="lotteryList-wrapper-content-close" @click="showPrizeList = false"></span>
      <p class="lotteryList-wrapper-content-title">我的奖品</p>
      <div class="lotteryList-wrapper-content-list">
        <ul>
          <li class="lotteryList-wrapper-content-list-item" v-for="(item, index) in prizeList" :key="index">
            <div class="object" v-if="item.type === 'object'">
              <div class="lotteryList-wrapper-content-list-item-object-top">
                <div class="lotteryList-wrapper-content-list-item-object-top-left">
                  <img :src="item.pic" alt="">
                </div>
                <div class="lotteryList-wrapper-content-list-item-object-top-right">
                  <p class="lotteryList-wrapper-content-list-item-object-top-right-name">中奖奖品：<span>{{item.prize}}</span></p>
                  <p class="lotteryList-wrapper-content-list-item-object-top-right-date">中奖日期：<span>{{item.date}}</span></p>
                </div>
                <div class="lotteryList-wrapper-content-list-item-object-top-button">
                  <button @click="openExpressLink"></button>
                </div>
              </div>
            </div>
            <div class="wequan" v-if="item.type === 'wequan'">
              <div class="lotteryList-wrapper-content-list-item-wequan-top">
              <div class="lotteryList-wrapper-content-list-item-wequan-top-left">
                <img :src="item.pic" alt="">
              </div>
              <div class="lotteryList-wrapper-content-list-item-wequan-top-right">
                <p class="lotteryList-wrapper-content-list-item-wequan-top-right-name">中奖奖品：<span>{{item.prize}}</span></p>
                <p class="lotteryList-wrapper-content-list-item-wequan-top-right-date">中奖日期：<span>{{item.date}}</span></p>
              </div>
              <div class="lotteryList-wrapper-content-list-item-wequan-top-button">
                <button disabled></button>
              </div>
              </div>
            </div>
            <div class="redeem" v-if="item.type === 'redeem'">
              <div class="lotteryList-wrapper-content-list-item-redeem-top">
              <div class="lotteryList-wrapper-content-list-item-redeem-top-left">
                <img :src="item.pic" alt="">
              </div>
              <div class="lotteryList-wrapper-content-list-item-redeem-top-right">
                <p class="lotteryList-wrapper-content-list-item-redeem-top-right-name">中奖奖品：<span>{{item.prize}}</span></p>
                <p class="lotteryList-wrapper-content-list-item-redeem-top-right-date">中奖日期：<span>{{item.date}}</span></p>
              </div>
              <div class="lotteryList-wrapper-content-list-item-redeem-top-button">
                <button v-clipboard:copy="item.code" v-clipboard:success="onCopy"></button>
              </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
import BScroll from 'better-scroll';
export default {
  data() {
    return{
      prizeList: [],
      showPrizeList: false,
      isAir: false,
    } 
  },
  methods: {
    getPrizeList() {
      this.$http.prizeList({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_luckydraw_gift_click'},{headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}}).then((res) => {
        if(res.code === 10005){
          localStorage.clear();
          this.$bus.emit('resetLogin');
          this.$bus.emit('resetluckyTimes');
          this.$toast({
            message: '登录已失效，请重新登录!',
            duration: 1500,
          });
          this.$bus.emit('showLoginBox');
          return false;
        }
        if(res.data.length > 0){
          this.prizeList = res.data;
          this.isAir = false;
        } else {
          this.isAir = true;
        }
        this.showPrizeList = true;
      })
    },
    openExpressLink() {
      // location.href = 'http://act.feng.com/meet/index.php?r=expressage/index';
      window.open('http://act.feng.com/meet/index.php?r=expressage/index')
    },
    onCopy() {
      clearTimeout(this.copyTimer)
      this.copyTimer = setTimeout(() => {
        this.$toast({
          message: '复制成功',
          duration: 1500,
          type: 'success'
        })
      }, 500)
    }
  },
  mounted() {
    this.$bus.on('showlotteryList', () => {
      localStorage.getItem('isLogin') === 'true' ? this.getPrizeList() : this.$toast({
        message: '请您先登录',
        duration: 2000,
      });
    })
    this.$nextTick(() => {
      new BScroll('.lotteryList-wrapper-content-list', {
        scrollY: true,
        mouseWheel: {
          speed: 20,
          invert: false,
          easeTime: 300
        },
        scrollbar: {
          fade: false,
          interactive: false
        }
        // scrollbar: true,
      });
      this.$('.bscroll-indicator').css({'background': 'rgba(210,213,217,1)', 'border-radius': '4px', 'border': 'none'});
      this.$('.bscroll-vertical-scrollbar').css({'right': '0'});
    })
    // this.$('.bscroll-indicator').css({'background': 'rgba(210,213,217,1)', 'border-radius': '4px', 'border': 'none'});
    // this.$('.bscroll-vertical-scrollbar').css({'right': '0', 'opacity': '1'});
    //解决滑动穿透
    const oLogin = document.querySelector('.lotteryList-wrapper');
    oLogin.addEventListener('touchmove', (e) => {
      e.preventDefault();
    }, false);
  }
}
</script>



// WEBPACK FOOTER //
// src/blocks/LotteryList.vue